<div class="w-8 m-auto py-5">
    <h1 class="text-2xl md:text-4xl">Formas de contacto</h1>
    <ul>
        <li>
            <p class="font-bold">Contacto y Servicio al cliente (Únicamente Anunciantes)</p>
            <p>Destinado a las escorts que tienen o desean crear un perfil en el sitio web: contactar directamente al
                <button pButton class="white vertical-align-baseline p-0" label="Whatsapp para anunciantes" icon="pi pi-external-link" iconPos="right"
                    (click)="contactUs()"></button>
            </p>
        </li>
        <li>
            <p class="font-bold">Contacto (Público en general)</p>
            <p>
                Destinado para informar sobre cualquier pregunta, duda, colaboración, queja, reclamo o denuncia de contenido en el sitio: contactar por medio del siguiente formulario:
            </p>
        </li>
    </ul>
    <div class="w-full md:w-8 m-auto py-3">
        <form [formGroup]="contactForm" (ngSubmit)="sendMail()">
            <div class="field mb-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <input type="text" id="name" pInputText class="p-inputtext-lg w-full" formControlName="name"
                        maxlength="50" minlength="1" autofocus="true"
                        [class.ng-invalid]="this.contactForm.get('name')?.invalid && this.contactForm.get('name')?.touched" />
                    <label htmlFor="name">Nombre</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <input type="text" id="email" pInputText class="p-inputtext-lg w-full" formControlName="email"
                        maxlength="100" minlength="5"
                        [class.ng-invalid]="this.contactForm.get('email')?.invalid && this.contactForm.get('email')?.touched" />
                    <label htmlFor="email">Correo electrónico</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <input type="text" id="subject" pInputText class="p-inputtext-lg w-full" formControlName="subject"
                        maxlength="100" minlength="2"
                        [class.ng-invalid]="this.contactForm.get('subject')?.invalid && this.contactForm.get('subject')?.touched" />
                    <label htmlFor="subject">Asunto</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <textarea rows="5" cols="30" id="message" pInputTextarea class="p-inputtext-lg w-full" formControlName="message"
                        maxlength="2000"
                        [class.ng-invalid]="this.contactForm.get('message')?.invalid && this.contactForm.get('message')?.touched">
                    </textarea>
                    <label htmlFor="message">Mensaje</label>
                </span>
                <label class="contador">{{ this.contactForm.get('message')?.value.length }}/2000</label>
            </div>
            <div class="flex justify-content-center my-3">
                <p-button label="Enviar mensaje" type="sumbit" [loading]="loading" [disabled]="contactForm.invalid || loading"></p-button>
            </div>
        </form>
    </div>
</div>